class GraphicLayer {
	static fromArray(data) {
		let inst = new GraphicLayer();
		inst._graphic = data.shift();
		inst._order = data.shift();
		inst._x = data.shift();
		inst._y = data.shift();
		inst._s = data.shift();
		inst._r = data.shift();
		inst._f = data.shift();

		inst.init();
		return inst;
	}

	static newWithId(graphic) {
		let inst = new GraphicLayer();
		inst._graphic = graphic;
		inst.init();
		return inst;
	}
	
	static newWithFile(file) {
		let inst = new GraphicLayer();
		inst.initFile(file);
		return inst;
	}
	
	static newWithUrl(url) {
		let inst = new GraphicLayer();
		inst.initUrl(url);
		return inst;
	}

	constructor() {
		this._graphic = null;
		this._order = 1;
		this._x = 0;
		this._y = 0;
		this._s = 0;
		this._r = 0;
		this._f = null;

		this._w;
		this._h;
		this._loaded = false;

		this._thumb = new Image();
		this._img = new Image();
		this._img.crossOrigin = 'Anonymous';
		this._canvas = document.createElement('canvas');
		this._thumbTile = null;
	}
	
	get thumbTile() {
		if (this._thumbTile === null) {
			this._thumbTile = div('thumb-tile', [
				this._thumb,
				this._removeBtn = btn('btn thumb-remove-btn i-rg i-delete', null, {
					'click' : () => {document.dispatchEvent(new CustomEvent('layerRemove', {detail: this._order}))}
				}),
				this._moveUpBtn = btn('btn layer-up i-rg i-chev-up', null, {
					'click' : () => {document.dispatchEvent(new CustomEvent('layerUp', {detail: this._order}))}
				}),
				this._moveDnBtn = btn('btn layer-dn i-rg i-chev-down', null, {
					'click' : () => {document.dispatchEvent(new CustomEvent('layerDn', {detail: this._order}))}
				})
			]);
			onEv(this._thumb, 'click', () => {
				document.dispatchEvent(new CustomEvent('layerSelect', {detail: this._order}));
			});
		}
		return this._thumbTile;
	}

	get w() {return this._w * this._s;}

	get h() {return this._h * this._s;}

	get loaded() {return this._loaded;}
	
	init() {
		this._img.onload = () => {
			this.measure();
		}
		this._img.src = graphicSrc(this._graphic, AC.GRAPHIC_FULL);
		this._thumb.src = graphicSrc(this._graphic, AC.GRAPHIC_SML);
	}
	
	initUrl(url) {
		this._img.onload = () => {
			this.measure();
		}
		this._img.src = url;
	}
	
	initFile(file) {
		this._img.onload = () => {
			URL.revokeObjectURL(this._img.src);
			this.measure();
		}
		this._img.src = URL.createObjectURL(file);
		this._img.file = file;
	}

	measure() {
		this._loaded = true;
		this._w = this._img.naturalWidth;
		this._h = this._img.naturalHeight;
		if (this._s === 0) this.fit();
		document.dispatchEvent(new CustomEvent('layerLoaded', {detail: this._order}));
		this.update();
	}

	fit() {
		this._s = 400 / Math.min(this._w, this._h);
		this._r = 0;
		this._x = 200 - this.w / 2;
		this._y = 200 - this.h / 2;
	}

	update() {
		this._canvas.style.transform = 'rotate(' + this._r + 'deg)';
		this._canvas.style.left = this._x + 'px';
		this._canvas.style.top = this._y + 'px';
		this._canvas.width = this._w * this._s;
		this._canvas.height = this._h * this._s;
		this._canvas.getContext('2d').drawImage(this._img, 0, 0, this._canvas.width, this._canvas.height);
	}

	center() {
		return {
			'x' : this._x + this.w / 2,
			'y' : this._y + this.h / 2
		};
	}

	hit(ev) {
		let bcr = this._canvas.getBoundingClientRect();
		let pt = point(ev);
		let ptPolar = cart2polar (
			pt.x - bcr.x - (bcr.width/2),
			pt.y - bcr.y - (bcr.height/2)
		);
		
		let ptCart = polar2cart(ptPolar.r, ptPolar.a - this._r);
		let ctx = this._canvas.getContext('2d');
		let data = ctx.getImageData(ptCart.x + ((this._w * this._s)/2), ptCart.y + ((this._h * this._s)/2), 1, 1).data;
		return data[3] != 0;
	}

	map() {
		return {
			"graphic": this._graphic,
			"order": this._order,
			"x": this._x,
			"y": this._y,
			"s": this._s,
			"r": this._r,
			"f": this._f
		};
	}

	set order(value) {this._order = value;}
}